import BaseService from './BaseService';
import { Creator } from 'pages/VideoCreative/types';

// Roster of UGC content creators. Backed by the Video Creative API
// (/v1/creative-intelligence/creators) — creators are part of the CI surface,
// even though the UI lives in its own "Creators" tab and uses this service.
// Every mutation returns the full, freshly-read list so the page can replace
// its local state with the server's source of truth.
class CreatorsService extends BaseService {
  private basePath = 'v1/creative-intelligence';

  async listCreators(): Promise<{ creators: Creator[] } | null> {
    await this._getAccessToken();
    return this.handleHttpRequest(
      () => this.http.get(`${this.basePath}/creators`),
      'Failed to fetch creators',
    );
  }

  async createCreator(firstName: string, lastName: string): Promise<{ creators: Creator[] } | null> {
    await this._getAccessToken();
    return this.handleHttpRequest(
      () => this.http.post(`${this.basePath}/creators`, { firstName, lastName }),
      'Failed to create creator',
    );
  }

  async updateCreator(creatorId: string, firstName: string, lastName: string): Promise<{ creators: Creator[] } | null> {
    await this._getAccessToken();
    return this.handleHttpRequest(
      () => this.http.put(`${this.basePath}/creators/${creatorId}`, { firstName, lastName }),
      'Failed to update creator',
    );
  }

  async deleteCreator(creatorId: string): Promise<{ creators: Creator[] } | null> {
    await this._getAccessToken();
    return this.handleHttpRequest(
      () => this.http.delete(`${this.basePath}/creators/${creatorId}`),
      'Failed to delete creator',
    );
  }
}

export default CreatorsService;
